// extracted by mini-css-extract-plugin
export default {"HostServiceDetailHeading__Name":"HostServiceDetailHeading_HostServiceDetailHeading__Name__HK+Rx"};